export const FILTER_CATEGORY_NAME = 'filter';
export const FILTER_CATEGORY_ID = -2;


// WEBPACK FOOTER //
// ./src/const/filter_const.js